import {  HateoasResource, Resource} from '@lagoshny/ngx-hateoas-client';
import {ProcessExecution} from "./V2/process-execution";

@HateoasResource('executions', { routeName: 'customerResourceRoute' })
export class CustomerProcessExecution extends ProcessExecution {}
